module.exports = __webpack_public_path__ + "185a83b947658e6c6b0d8b25a06af293.pdf";